<template lang="pug">
  .create-plan_rate-reservation-rates
    .tabs-inner-content
      pre
      .row
        .columns
          h2 Plan reservation rate
          hr
          label Name
            input(type="text", v-model="plan_rate.name")
          label Vehicle Category
            selectize-category(@optionSelected="selectCategory")
          label Reservation rate
            selectize-reservation-rate(@optionSelected="selectRate")

          label Disabled
            input(type="checkbox", v-model="plan_rate.disabled")
        .column
          BookingModeSelect(v-model="booking_modes", type="checkbox")
      .row
        .columns.text-right
          a.button.success(@click="savePlanRate") Save
</template>
<script type="text/babel">

  import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
  import PlanReservationRate from "../PlanReservationRate.vue";
  import SelectizeCategory from "../../structure/ui/lists/selectize/SelectizeCategory";
  import SelectizeReservationRate from "../../structure/ui/lists/selectize/SelectizeReservationRate";
  import DatePicker from "../../structure/DatePicker";
  import MaggieHelper from "../../../maggieHelper";
  import BookingModeSelect from "../../structure/BookingModeSelect";


  export default {
    name: "PlanReservationRates",
    components: {BookingModeSelect, DatePicker, SelectizeReservationRate, SelectizeCategory, PlanReservationRate},
    data() {
      return {
        plan_rate: {
          name: null,
          vehicle_category_id: null,
          plan_id: null,
          reservation_rate_id: null,
          booking_mode: null,
          time_resolution_method: "ITWILLBEDEADSOON",
          time_resolution_cycle: 0,
          distance_resolution_method: "ITWILLBEDEADSOON",
          distance_resolution_cycle: 0,
          valid_from: null,
          valid_to: null,
          disabled: false,
        },
        booking_modes: []
      }
    },
    created() {

    },
    methods: {
      selectCategory(item) {
        this.plan_rate.vehicle_category_id = item.id
      },
      selectRate(item) {
        this.plan_rate.reservation_rate_id = item.id
      },
      savePlanRate() {
        this.plan_rate.booking_mode = this.booking_modes.join(',')
        this.plan_rate.plan_id = this.$route.params.id

        KeplerBackofficeSdk.planReservationRates.make(this.plan_rate, (data) => {
          MaggieHelper.notification('rate', 'Reservation rate created')
          this.$router.back()
        })

      }
    },
    computed: {}
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .create-plan_rate-reservation-rates
    background: white

</style>



// WEBPACK FOOTER //
// CreatePlanReservationRates.vue?572538fa